<img height="30px" *ngIf="rowData && rowData.brand_image" style="display: block;" [src]="rowData?.brand_image" />
<img *ngIf="displayValue == 5" src="assets/5stars.svg" />
<img *ngIf="displayValue == 4" src="assets/4stars.svg" />
<img *ngIf="displayValue == 3" src="assets/3stars.svg" />
<img *ngIf="displayValue == 2" src="assets/2stars.svg" />
<img *ngIf="displayValue == 1" src="assets/1stars.svg" />
<img *ngIf="displayValue == 0" src="assets/0stars.svg" />